import React from 'react';
import { Link } from 'react-router-dom';
import { theme } from '../theme';

const PrivacyPolicy: React.FC = () => {
  return (
    <div style={{
      backgroundColor: theme.colors.background,
      minHeight: '100vh',
      color: theme.colors.text,
      fontFamily: theme.fonts.body,
      padding: '24px 16px 48px'
    }}>
      <div style={{ maxWidth: '720px', margin: '0 auto' }}>
        <Link
          to="/"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            color: theme.colors.primary,
            textDecoration: 'none',
            fontSize: theme.fonts.sizeBody,
            marginBottom: '24px'
          }}
        >
          ← Volver al inicio
        </Link>

        <h1 style={{
          fontFamily: theme.fonts.heading,
          fontSize: '2rem',
          fontWeight: 700,
          marginBottom: '8px',
          color: theme.colors.text
        }}>
          Política de Privacidad
        </h1>
        <p style={{ color: theme.colors.textSecondary, marginBottom: '32px', fontSize: theme.fonts.sizeSmall }}>
          Última actualización: enero de 2025
        </p>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: 700,
            color: theme.colors.primary,
            marginBottom: '12px'
          }}>1. Responsable del tratamiento</h2>
          <p style={{ color: theme.colors.textSecondary, lineHeight: 1.7, margin: 0 }}>
            Futbolero es la aplicación móvil y el sitio web disponible en futbolero.ar, destinados a la organización y gestión de partidos de fútbol. 
            Para cualquier consulta relacionada con el tratamiento de sus datos personales, puede dirigirse a <a href="mailto:futboleroapp@gmail.com" style={{ color: theme.colors.primary }}>futboleroapp@gmail.com</a>.
          </p>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: 700,
            color: theme.colors.primary,
            marginBottom: '12px'
          }}>2. Datos recopilados</h2>
          <p style={{ color: theme.colors.textSecondary, lineHeight: 1.7, marginBottom: '12px' }}>
            Futbolero puede recopilar y procesar los siguientes tipos de datos:
          </p>
          <ul style={{ color: theme.colors.textSecondary, lineHeight: 1.8, paddingLeft: '20px', margin: 0 }}>
            <li><strong style={{ color: theme.colors.text }}>Datos de cuenta:</strong> dirección de correo electrónico y nombre, obtenidos a través del inicio de sesión con Google. Son necesarios para la identificación del usuario y el acceso al servicio.</li>
            <li><strong style={{ color: theme.colors.text }}>Imagen de perfil:</strong> fotografías que el usuario decide subir de forma voluntaria. Su provisión es opcional.</li>
            <li><strong style={{ color: theme.colors.text }}>Identificador del dispositivo:</strong> utilizado exclusivamente para el envío de notificaciones push (recordatorios de partidos, confirmaciones de inscripción, etc.), únicamente cuando el usuario ha autorizado dichas notificaciones.</li>
            <li><strong style={{ color: theme.colors.text }}>Datos proporcionados por el usuario:</strong> lugar del partido (denominación o enlace de mapa), fecha, hora, lista de jugadores, reseñas y cualquier otra información que el usuario introduzca al utilizar la aplicación o el sitio web.</li>
          </ul>
          <p style={{ color: theme.colors.textSecondary, lineHeight: 1.7, marginTop: '12px', marginBottom: 0 }}>
            Futbolero no utiliza la geolocalización GPS del dispositivo. Los datos de ubicación de los partidos consisten únicamente en texto o enlaces que el usuario escribe o pega manualmente.
          </p>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: 700,
            color: theme.colors.primary,
            marginBottom: '12px'
          }}>3. Finalidad del tratamiento</h2>
          <p style={{ color: theme.colors.textSecondary, lineHeight: 1.7, margin: 0 }}>
            Los datos recopilados se utilizan para: facilitar el acceso a la cuenta y la gestión de la misma; administrar partidos, inscripciones y equipos; enviar notificaciones que el usuario haya aceptado; mostrar el perfil y la imagen de perfil a otros jugadores en el marco de los partidos; mejorar el funcionamiento del servicio; y cumplir con las obligaciones legales aplicables.
          </p>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: 700,
            color: theme.colors.primary,
            marginBottom: '12px'
          }}>4. Almacenamiento y seguridad</h2>
          <p style={{ color: theme.colors.textSecondary, lineHeight: 1.7, margin: 0 }}>
            Los datos se almacenan en servidores que aplican medidas técnicas y organizativas adecuadas para reducir los riesgos de acceso no autorizado, pérdida o alteración. Las comunicaciones con la aplicación y el sitio web se realizan mediante el protocolo HTTPS. Si bien no es posible garantizar una seguridad absoluta, Futbolero adopta las medidas razonables para proteger la información de los usuarios.
          </p>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: 700,
            color: theme.colors.primary,
            marginBottom: '12px'
          }}>5. Derechos del usuario</h2>
          <p style={{ color: theme.colors.textSecondary, lineHeight: 1.7, margin: 0 }}>
            El usuario puede acceder a los datos asociados a su cuenta desde la aplicación o desde su perfil. Para solicitar la rectificación, la baja del servicio o la supresión de sus datos, debe contactar a <a href="mailto:futboleroapp@gmail.com" style={{ color: theme.colors.primary }}>futboleroapp@gmail.com</a>. Cuando la normativa aplicable lo permita, el usuario podrá también presentar una reclamación ante la autoridad de control competente.
          </p>
        </section>

        <section style={{ marginBottom: '28px' }}>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: 700,
            color: theme.colors.primary,
            marginBottom: '12px'
          }}>6. Modificaciones</h2>
          <p style={{ color: theme.colors.textSecondary, lineHeight: 1.7, margin: 0 }}>
            Futbolero se reserva el derecho de actualizar esta Política de Privacidad. La fecha de «Última actualización» reflejará la última modificación. El uso continuado de la aplicación o del sitio web con posterioridad a los cambios implica la aceptación de la versión vigente. En caso de modificaciones sustanciales, se notificará a través de la aplicación, el sitio web o por correo electrónico cuando sea procedente.
          </p>
        </section>

        <section>
          <h2 style={{
            fontSize: '1.25rem',
            fontWeight: 700,
            color: theme.colors.primary,
            marginBottom: '12px'
          }}>7. Contacto</h2>
          <p style={{ color: theme.colors.textSecondary, lineHeight: 1.7, margin: 0 }}>
            Para consultas relativas a la privacidad o a esta política, diríjase a <a href="mailto:futboleroapp@gmail.com" style={{ color: theme.colors.primary }}>futboleroapp@gmail.com</a>.
          </p>
        </section>

        <div style={{ marginTop: '40px', paddingTop: '24px', borderTop: `1px solid ${theme.colors.border}` }}>
          <Link
            to="/"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              color: theme.colors.primary,
              textDecoration: 'none',
              fontSize: theme.fonts.sizeBody
            }}
          >
            ← Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
